<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


function addPublished(){
if(document.querySelector('.blog-date')){
    var blogDateHTML = `<span>Published:</span>`
    return document.querySelector('.blog-date').insertAdjacentHTML("beforebegin", blogDateHTML)
}}

function changeCheckoutText(){
    if(document.querySelector('#cart-checkout')){
        var checkout = "Checkout Securely"
        return document.querySelector('#cart-checkout').textContent = checkout;
    }}


addPublished();
changeCheckoutText();

function closeTapcart(){
  console.log("test")
}